import samanthaPic from "@/public/images/artists/samantha.png";
import { Artist } from "@/types/types";

export const samantha = {
  id: "144",
  name: "Samantha",
  image: samanthaPic,
  description: `Samantha's voice, with its rich resonance and advanced technical skill, is ideal for soul music, allowing her to belt out melodies with precision and strength. Her powerful delivery and confident presence command attention, effortlessly channeling the spirit of soul and disco legends.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fsamantha-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: [
        "Jazz",
        "Country",
        "Soul",
        "Indie",
        "Blues",
        "Pop",
        "Funk",
        "Disco",
        "Dance",
        "Unprocessed",
        "Belting",
      ],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "Very high",
      },
      specific: {
        low: 57,
        high: 72,
      },
      sweetSpot: 64,
    },
  },
} as const satisfies Artist;
